module.exports = __webpack_public_path__ + "static/polyester-ef3978a7dad7d0dff6511c68a20292a4.jpg";